import React, { useEffect, useLayoutEffect, useMemo } from "react"
import { createContext, useContext } from "react"
import { TApiSetup } from "../../types/api"
import { WithChildren } from "../../../_metronic/helpers"
import useSetup from "../../api/hooks/useSetup"
import {setDocumentTitle, setFavicon, setStyles} from './dynamicStyles'


type TSetupContext = { context: TApiSetup, refetch: () => void }
const SetupContext = createContext<TSetupContext>({ context: {}, refetch: () => { } })
export const useSetupContext = () => useContext(SetupContext)

const SetupContextProvider: React.FC<WithChildren> = ({ children }) => {
  const { data, refetch } = useSetup()
  useLayoutEffect(() => {
    setDocumentTitle()
    setFavicon()
    /* в метронике есть запуск. Нужно проработать */
    document.body.setAttribute('data-kt-app-header-fixed', 'true')
    document.body.setAttribute('data-kt-app-header-fixed-mobile', 'true')
  }, [])
  useEffect(() => {
    if (data) {
      setStyles(data.theme)
      if (data.is_sign) {
        const script = document.createElement("script")
        script.src = "/cryptopro/cadesplugin_api.js"
        document.body.appendChild(script)
      }
    }
  }, [data])

  const context = useMemo(() => ({
    context: data ?? {},
    refetch
  }
  ), [data])

  return <SetupContext.Provider value={context} >{children}</SetupContext.Provider>
}

export default SetupContextProvider